import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private readonly logout = new Subject<void>();
  private readonly switchAccount = new Subject<void>();

  public dispatchLogout(): void {
    this.logout.next();
  }

  public dispatchAccountSwitch(): void {
    this.switchAccount.next();
  }

  public logout$(): Observable<void> {
    return this.logout.asObservable();
  }

  public switchAccount$(): Observable<void> {
    return this.switchAccount.asObservable();
  }
}
